import React from "react";

import { Tooltip } from "@components/tooltip-container";
import { type TableHeaderRow } from "@devexpress/dx-react-grid-bootstrap4";
import { useClientSettings } from "@pages/mmm/hooks/use-client-settings";

export const SpendTrackerHeaderContent = ({
  column,
  children,
}: TableHeaderRow.ContentProps) => {
  const { formattedMixToDateRange } = useClientSettings();

  return (
    <>
      <div className="text-xs w-full flex items-center px-2">
        <span className="overflow-hidden min-w-[10px] flex-1">
          {children}
          {` (${formattedMixToDateRange})`}
          <Tooltip
            content={
              <div className="w-80">
                <div>
                  This shows how your actual spend is tracking against what was
                  budgeted by MMM+ to date. The target shows your budget for the
                  current period.
                </div>
                <div className="mt-2">
                  Learn more from the{" "}
                  <a
                    href="https://info.northbeam.io/knowledge/get-started-with-mmm"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Northbeam Knowledge Base
                  </a>
                  .
                </div>
              </div>
            }
          />
        </span>
      </div>
      <div className="header-column-separator"></div>
    </>
  );
};
